import CollectionPage from './collection/[chain]/[address]';

export default CollectionPage;
